import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { IconTrending } from "src/components/icons";
import { TAggregatedReactions } from "src/types/common";

export interface ITotalInteractions {
    commentCount?: number;
    likeCount?: number;
    reactions?: TAggregatedReactions;
}

export const TotalInteractions = ({ commentCount = 0, likeCount = 0, reactions = [] }: ITotalInteractions) => {
    const totalInteractions = commentCount + likeCount + reactions.reduce((sum, reaction) => sum + (reaction.numberOfReactions ?? 0), 0);

    return totalInteractions ? (
        <Flex alignItems="center">
            <IconTrending boxSize={3} />
            <Text pl={0.5} overflow="hidden" whiteSpace="nowrap" fontWeight="semibold" fontSize="sm">
                {totalInteractions}
            </Text>
        </Flex>
    ) : null;
};
